<template>
  <div
    class="modal fade"
    :class="show ? 'show' : 'hide'"
    style="display: block; background-color: rgba(0, 0, 0, 0.3)"
  >
    <ErrorDetailsPopup ref="error-details-popup" :file="preparedErrorFile" />
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Version Control - {{ currentFile.name }}</h4>
        </div>
        <div class="modal-body" v-if="!versionHistoryFiles.length">
          <div class="modal-body-content-2">
            <el-card class="align-items-start">
              <div class="clearfix">
                <h6>
                  <span class="bold">Current file has no version histor</span>y
                </h6>
              </div>
            </el-card>
          </div>
        </div>
        <div v-else class="modal-body">
          <div class="modal-body-content">
            <el-card class="selected-file">
              <template #header>
                <div class="clearfix">
                  <h6>
                    Current file:
                    <span class="bold">{{
                      currentHistoryFile.current_file
                    }}</span>
                    <i
                      v-if="
                        currentHistoryFile.errors &&
                        currentHistoryFile.errors.length
                      "
                      class="el-icon-warning"
                      style="color: #ec4141"
                    ></i>
                    <i v-else class="el-icon-success" style="color: #4cea54"></i>
                  </h6>
                </div>
              </template>
              <el-descriptions :column="1">
                <el-descriptions-item label="File Name">{{
                  currentHistoryFile.current_file
                }}</el-descriptions-item>
                <el-descriptions-item label="Upload date">{{
                  `${currentHistoryFile.date.slice(0, 10)} ${currentHistoryFile.date.slice(11, 19)}`
                }}</el-descriptions-item>
              </el-descriptions>
              <h6
                v-if="
                  currentHistoryFile.errors && currentHistoryFile.errors.length
                "
              >
                Error
              </h6>
              <div v-for="err in currentHistoryFile.errors" :key="err.id">
                <span class="bold">{{ err.high_msg }}</span>
              </div>
              <el-button
                v-if="
                  currentHistoryFile.errors && currentHistoryFile.errors.length
                "
                class="mt-1 ml-0"
                tslot="trigger"
                size="small"
                type="primary"
                @click="
                  () => {
                    errorDetailsPopup(
                      currentHistoryFile.current_file,
                      currentHistoryFile.date,
                      currentHistoryFile.errors
                    );
                  }
                "
              >
                Error Details
              </el-button>
            </el-card>
            <el-card v-if="selectedFile">
              <template #header>
                <div class="clearfix">
                  <h6>
                    <el-button
                      type="primary"
                      icon="el-icon-refresh-right"
                      @click="save"
                    >
                      Revert
                    </el-button>
                    Selected File:
                    <span class="bold">{{ selectedFile.name }}</span>
                    <i
                      v-if="selectedFile.errors.length"
                      class="el-icon-warning"
                      style="color: #ec4141"
                    ></i>
                    <i v-else class="el-icon-success" style="color: #4cea54"></i>
                  </h6>
                </div>
              </template>
              <el-descriptions :column="1">
                <el-descriptions-item label="File Name">{{
                  selectedFile.name
                }}</el-descriptions-item>
                <el-descriptions-item label="Upload date">{{
                  `${selectedFile.date.slice(0, 10)} ${selectedFile.date.slice(11, 19)}`
                }}</el-descriptions-item>
              </el-descriptions>
              <template v-if="selectedFile">
                <el-descriptions
                  v-for="err in selectedFile.errors"
                  :key="err.id"
                  title="Error"
                >
                  <el-descriptions-item>
                    {{ err.high_msg }}
                  </el-descriptions-item>
                </el-descriptions>
                <el-button
                  v-if="selectedFile.errors && selectedFile.errors.length"
                  class="mt-1 ml-0"
                  tslot="trigger"
                  size="small"
                  type="primary"
                  @click="
                    () => {
                      errorDetailsPopup(
                        selectedFile.name,
                        selectedFile.date,
                        selectedFile.errors
                      );
                    }
                  "
                >
                  Error Details
                </el-button>
              </template>
            </el-card>
          </div>

          <div class="table-container">
            <div class="d-flex justify-content-around table-header">
              <div class="column-header" style="width: 5%">
                <span class="mr-1"></span>
              </div>
              <div class="column-header" style="width: 15%">
                <span class="mr-1">Date</span>
              </div>
              <div class="column-header" style="width: 15%">
                <span class="mr-1">Time</span>
              </div>
              <div class="column-header" style="width: 50%">
                <span class="mr-1">Filename</span>
              </div>
              <div class="column-header" style="width: 15%">
                <span class="mr-1">Status</span>
              </div>
            </div>
            <div class="scroll-wrapper" style="height: calc(100% - 50px)">
              <RecycleScroller
                class="scroller"
                :items="versionHistoryFiles"
                :item-size="50"
                keyField="id"
              >
                <template v-slot="{ item }">
                  <div
                    class="
                      data
                      d-flex
                      flex-column
                      justify-content-center
                      align-items-center
                    "
                  >
                    <div class="main-data" style="padding: 0 10px">
                      <div class="column-body" style="width: 5%">
                        <input
                          type="radio"
                          v-model="selectedFile"
                          :value="item"
                          :id="item.id"
                        />
                      </div>
                      <div class="column-body" style="width: 15%">
                        {{ item ? item.date.slice(0, 10) : "" }}
                      </div>
                      <div class="column-body" style="width: 15%">
                        {{ item ? item.date.slice(11, 19) : "" }}
                      </div>
                      <div class="column-body" style="width: 50%">
                        {{ item ? item.name : "" }}
                      </div>
                      <div class="column-body" style="width: 15%">
                        <template
                          v-if="item.errors ? item.errors.length : null"
                        >
                          <span style="color: red"> Failed </span>
                        </template>
                        <span v-else style="color: green">Success</span>
                      </div>
                    </div>
                  </div>
                </template>
              </RecycleScroller>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn light-button" @click="close" type="button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import ErrorDetailsPopup from '../FileStructure/ErrorDetailsPopup'

export default {
  name: 'VersionControlPopup',
  components: { ErrorDetailsPopup },
  props: {
    id: String,
    currentFile: {
      type: Object,
      default: null
    },
    folderType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false,
      selectedFile: null,
      nextLocation: null,
      versionHistoryFiles: [],
      currentHistoryFile: {},
      defaultCurrentHistoryFile: {
        currentFile: '',
        date: '',
        errors: []
      },
      preparedErrorFile: {
        name: '',
        date: '',
        errors: []
      }
    }
  },
  methods: {
    async showPopup (nextLocation) {
      if (nextLocation) {
        this.nextLocation = nextLocation
      }
      console.log('current File: ', this.currentFile)
      await this.getVersionHistory()
      this.show = true
    },
    closePopup () {
      this.show = false
      this.selectedFile = null
      this.currentHistoryFile = this.defaultCurrentHistoryFile
    },
    close () {
      this.closePopup()
    },
    async save () {
      try {
        await this.axios({
          url:
            '/study/' +
            this.id +
            '/swap-version-file/' +
            this.currentFile.name +
            '/' +
            this.selectedFile.id,
          method: 'POST',
          responseType: '',
          data: {
            filetype: this.currentFile.file_type,
            foldertype: this.folderType
          }
        })
        this.$emit('refresh')
        this.close()
      } catch (e) {
        console.log(e)
      }
    },
    async getVersionHistory () {
      await this.axios({
        url: `/study/${this.id}/version-history/${this.currentFile.name}`,
        method: 'POST',
        responseType: '',
        data: {
          foldertype: this.folderType
        }
      })
        .then(response => {
          if (response.data._source.file_history) {
            this.versionHistoryFiles = response.data._source.file_history.sort(
              (a, b) => {
                a = new Date(a.date).getTime()
                b = new Date(b.date).getTime()
                return b - a
              }
            )
          } else {
            this.versionHistoryFiles = []
          }
          this.currentHistoryFile = response.data._source
          if (!this.currentHistoryFile.errors) {
            this.currentHistoryFile.errors = []
          }
        })
        .catch(response => {
          this.versionHistoryFiles = []
          this.currentHistoryFile = this.defaultCurrentHistoryFile
        })
    },
    errorDetailsPopup (name, date, errors) {
      this.preparedErrorFile = {
        name,
        date,
        errors
      }
      this.$refs['error-details-popup'].showPopup()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.hide {
  height: 0;
}

.show {
  height: 100%;
}
.bold {
  font-weight: bold;
}
.modal-dialog {
  margin-top: 80px;
  margin-left: 300px;
}

.modal-content {
  width: 60vw;
  max-height: 80vh;
  min-height: 215px;
  background-color: white !important;
  border: 1px solid #d1d4d7 !important;
  border-radius: 4px;
  overflow-y: scroll;

  .modal-header {
    display: flex;
    justify-content: flex-start;
    height: 42px;
    width: 100%;
    margin-top: 33px;
    align-items: flex-end;
    padding-left: 42px;

    .modal-title {
      font-family: "Source Sans Pro", sans-serif;
      font-size: 20px;
      font-weight: 900;
      line-height: 23px;
      letter-spacing: 0;
      margin-left: 41px;
    }
  }

  .modal-body {
    margin-top: 10px;
    margin-left: 10px;
    display: block;
    .selected-file {
      margin-bottom: 20px;
    }
    margin-right: 10px;
    .modal-body-content {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      width: 100%;
      margin-top: 14px;
      align-items: flex-end;
      padding-left: 14px;
    }

    .modal-body-content-2 {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      width: 100%;
      margin-top: 14px;
      padding-left: 14px;
    }

    span {
      font-family: "Source Sans Pro", sans-serif;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0;
    }

    .table-container {
      height: 400px;
      overflow-x: auto;
    }
  }
}

.vue-recycle-scroller__item-wrapper {
  height: 40px;
}

.table-header {
  z-index: 3;
  position: sticky;
  top: 0;
  background-color: #d1d4d7;
  border-bottom: 1px solid #d1d4d7;
}

.column-header {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  transition: 0.1s background-color linear;
}

.main-data {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 50px;
  width: 100%;
  cursor: pointer;
}

.column-body {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 20px;
}

.scroller {
  height: 100%;
}
</style>
